<template lang="pug">
  component(:is="component")
</template>
<script>
export default {
  name: 'Success',
  components: {
    customer: () => import(/* webpackChunkName: "Customer" */'@/views/Success/Customer.vue'),
    employee: () => import(/* webpackChunkName: "Employee" */'@/views/Success/Employee.vue')
  },
  data () {
    return {
      componentList: {
        checkout: 'customer',
        funcionario: 'employee'
      }
    }
  },
  computed: {
    component () {
      return this.componentList[process.env.VUE_APP_JOURNEY_NAME]
    }
  }
}
</script>
